import type { PrintDataPayload } from 'generated/graphql';

/**
 * Build variables for postPrintDataSocket. GraphQL rejects e.g. [] for scalar fields;
 * omit invalid optional values instead of sending them.
 */
export function buildPrintDataSocketVariables(
	printData: Record<string, unknown>,
): { printData: PrintDataPayload } | null {
	const outletID = printData.outletID;
	const printerName = printData.printerName;
	const outletName = printData.outletName;
	const orderID = printData.orderID;
	const orderItemIDs = printData.orderItemIDs;
	const orderMode = printData.orderMode;

	if (
		typeof outletID !== 'string' ||
		!outletID ||
		typeof printerName !== 'string' ||
		!printerName ||
		typeof outletName !== 'string' ||
		!outletName ||
		typeof orderMode !== 'string' ||
		!orderMode ||
		typeof orderID !== 'string' ||
		!orderID
	) {
		return null;
	}

	let ids: string[] = [];
	if (Array.isArray(orderItemIDs)) {
		ids = orderItemIDs.filter((x): x is string => typeof x === 'string' && x.length > 0);
	} else if (orderItemIDs != null && orderItemIDs !== '') {
		ids = [String(orderItemIDs)];
	}

	const payload: Record<string, unknown> = {
		outletID,
		printerName,
		outletName,
		orderID,
		orderItemIDs: ids,
		orderMode,
	};

	const copyScalarIfValid = (key: string) => {
		const v = printData[key];
		if (v === undefined || v === null || Array.isArray(v)) return;
		payload[key] = v;
	};

	[
		'dataURL',
		'voidQuantity',
		'reasonCode',
		'remark',
		'userID',
		'connectType',
		'deviceIP',
		'devicePort',
		'deviceAlignmentCode',
		'deviceInfo',
		'isSDK',
	].forEach(copyScalarIfValid);

	return { printData: payload as PrintDataPayload };
}
